import React, { useState } from "react";
import styles from "./StockMonitoring.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar";
import ShippingCarrierPerformance from "../../../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/ShippingCarrierPerformance/ShippingCarrierPerformance";
import StockMonitoringDetails from "../../../../components/AdminPortalComponents/BusinessManagement/StockMonitoring/StockMonitoringDetails";
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import CustomModal from "../../../../components/common/AdminCommonComponents/CustomModal/CustomModal";
import ReportsAndInsights from "../../../../components/AdminPortalComponents/BusinessManagement/ReportsAndInsights/ReportsAndInsights";
import Toggle from "../../../../components/common/AdminCommonComponents/Toggle/Toggle";

const stockMonitoringData = [
    { title: "Total Products in Stock", value: 0 },
    { title: "Low Stock Products", value: 0 },
    { title: "Out-of-stock Products", value: 0 },
    { title: "Top Restocking Needs", value: 0 }
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));
const reportsAndInsightsData = [
    { title: "Low-stock products trends", value: 0 },
    { title: "stock turnover rate by category", value: 0 },
    { title: "top low-stock sellers", value: 0 },
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));

const tabsData = [
    { key: "1", label: "Stock Monitoring" },
    { key: "2", label: "Reporting & Insights" },
];
const StockMonitoring = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");
    const [modal, setModal] = useState(false)
    const [tab, setTab] = useState(false)
    const [isToggled, setIsToggled] = useState(false);

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.filterTableWrapper}>
                <div className={styles.squareFilterBarWrapper} onClick={() => setTab(!tab)}>
                    <DynamicSquaredFilterBar
                        tabs={tabsData}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        barType="default"
                    />
                </div>
                <Container fluid className={styles.orderWrapper}>
                    <h5 className={styles.mainHeading}>Stock Monitoring</h5>
                    <div className={styles.cardRowWrapper}>
                        <DynamicCardRow cards={tab === false ? stockMonitoringData : reportsAndInsightsData} />
                    </div>
                </Container>
                {tab === false ?
                    <div className="p-3 d-flex align-items-center justify-content-between">
                        <div className={`fw-semibold fs-4 ${styles.text} `}>Stock Monitoring</div>
                        <DynamicButton theme="blue"
                            onClick={() => setModal(true)}
                        >
                            Min. Stock Threshold
                        </DynamicButton>
                    </div>
                    :
                    <div className="p-3 d-flex align-items-center justify-content-between">
                        <div className={`fw-semibold fs-4 ${styles.text} `}>Stock Insight Table </div>

                    </div>
                }
                {activeTab === "1" && <StockMonitoringDetails />}
                {activeTab === "2" && <ReportsAndInsights />}
            </Container>
            {modal &&
                <CustomModal
                    isOpen={modal}
                    onClose={() => setModal(!modal)}
                    body={
                        <div className={styles.modal}>
                            <h2 className={styles.title}>Minimum Stock Threshold</h2>
                            <input type="text" placeholder="Enter a name" className={styles.input} />

                            <div className={styles.controls}>
                                <Toggle />
                                <DynamicButton theme="blue">Set</DynamicButton>
                            </div>
                        </div>
                    }
                />
            }

        </div>
    );
};

export default StockMonitoring;